import { css } from '@emotion/react';
import _ from 'lodash';
import type { ReactNode } from 'react';

import { contrastingTextColor, su, theme } from '@adflow/frontend/ui-theme';

const styles = {
	container: css(su.rounded3xl, {
		display: 'inline-flex',
		alignItems: 'center',
		alignSelf: 'center',
		justifyContent: 'space-between',
		height: '1.5rem',
		paddingLeft: '0.75rem',
		paddingRight: '0.75rem',
		':focus': { outline: '2px solid transparent', outlineOffset: '2px' },

		background: theme.colors.background.tag.green,
	}),

	text: css(su.fontSans, su.textSm, {
		color: theme.colors.text.primary,
		fontWeight: '400',
	}),
};

export interface StatusDisplayProps {
	status: string;
	backgroundColor: string;
	textColor?: string;
	leftIcon?: ReactNode;
	rightIcon?: ReactNode;
}
export function StatusDisplay({
	status,
	backgroundColor,
	textColor: textColorProp,
	leftIcon,
	rightIcon,
}: StatusDisplayProps) {
	const textColor = textColorProp ?? contrastingTextColor(backgroundColor);
	return (
		<span
			css={[
				styles.container,
				{ background: backgroundColor },
				backgroundColor === '#FFFFFF' &&
					css({
						borderColor: theme.colors.text.secondary,
						borderWidth: '1px',
					}),
			]}
		>
			{leftIcon}
			<span css={[styles.text, { color: textColor, whiteSpace: 'nowrap' }]}>
				{_.upperFirst(status)}
			</span>
			{rightIcon}
		</span>
	);
}
